module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=SJ - Svalbard and Jan Mayen.eabcc947.svg";